import { render, staticRenderFns } from "./ReceivablesAging.vue?vue&type=template&id=1342cd5c&"
import script from "./ReceivablesAging.vue?vue&type=script&lang=js&"
export * from "./ReceivablesAging.vue?vue&type=script&lang=js&"
import style0 from "./ReceivablesAging.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports